<template>
  <div
    class="form-group"
    :class="{ 'has-error': hasErrors }"
  >
    <slot name="label">
      <label
        class="label"
        v-if="label"
      >{{ label }} {{ validator.$params.required ? '' : '' }}</label>
    </slot>
    <div class="control is-danger">
      <slot />
    </div>
    <template v-if="hasErrors">
      <p
        class="help-block"
        v-for="(error,idx) in activeErrorMessages"
        :key="idx"
      >{{ error }}</p>
    </template>
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
  mixins: [singleErrorExtractorMixin]
};
</script>
<style>
.field.is-danger input {
  border-color: red;
}
</style>
